import React from 'react';
import { FilterType } from '../../model/FilterType';
import { t } from '../../i18n';

const TypeFilter = ({ type, showZonesAndGates, onChange }: Props) => {
  return (
    <div className="border-bottom w-100">
      <button type="button" className={`btn btn-label-secondary p-2 bg-white waves-effect me-2 mb-2 ${type === FilterType.all ? 'active' : ''}`} onClick={() => onChange(FilterType.all)}>
        <span className="ti ti-xs ti-circles"></span>
        <span className="ms-2">{t('filter.types.all')}</span>
      </button>
      <button type="button" className={`btn btn-label-secondary p-2 bg-white waves-effect me-2 mb-2 ${type === FilterType.location ? 'active' : ''}`} onClick={() => onChange(FilterType.location)}>
        <span className="ti ti-xs ti-location"></span>
        <span className="ms-2">{t('filter.types.location')}</span>
      </button>
      <button type="button" className={`btn btn-label-secondary p-2 bg-white waves-effect me-2 mb-2 ${type === FilterType.installation ? 'active' : ''}`} onClick={() => onChange(FilterType.installation)}>
        <span className="ti ti-xs ti-rotate-dot"></span>
        <span className="ms-2">{t('filter.types.installation')}</span>
      </button>
      <button type="button" className={`btn btn-label-secondary p-2 bg-white waves-effect me-2 mb-2 ${type === FilterType.campaign ? 'active' : ''}`} onClick={() => onChange(FilterType.campaign)}>
        <span className="ti ti-xs ti-device-analytics"></span>
        <span className="ms-2">{t('filter.types.campaign')}</span>
      </button>
      <button type="button" className={`btn btn-label-secondary p-2 bg-white waves-effect mb-2 ${type === FilterType.playlist ? 'active' : ''}`} onClick={() => onChange(FilterType.playlist)}>
        <span className="ti ti-xs ti-playlist"></span>
        <span className="ms-2">Playlist</span>
      </button>
      {showZonesAndGates ? <>
          <button type="button" className={`btn btn-label-secondary bg-white waves-effect mb-2 ${type === FilterType.zone ? 'active' : ''}`} onClick={() => onChange(FilterType.zone)}>
            <span className="ti ti-xs ti-map-pin"></span>
            <span className="ms-2">{t('filter.types.zone')}</span>
          </button>
          <button type="button" className={`btn btn-label-secondary bg-white waves-effect mb-2 ${type === FilterType.gate ? 'active' : ''}`} onClick={() => onChange(FilterType.gate)}>
            <span className="ti ti-xs ti-door"></span>
            <span className="ms-2">{t('filter.types.gate')}</span>
          </button>
          <button type="button" className={`btn btn-label-secondary bg-white waves-effect mb-2 ${type === FilterType.crossingLine ? 'active' : ''}`} onClick={() => onChange(FilterType.crossingLine)}>
            <span className="ti ti-xs ti-line"></span>
            <span className="ms-2">{t('filter.types.crossingLine')}</span>
          </button>
        </> : ''}
    </div>
  );
}

interface Props {
  type: FilterType,
  showZonesAndGates: boolean,
  onChange: (type: FilterType) => void
}

export { TypeFilter };
